
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pimLoad"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"currentUser"},"name":{"kind":"Name","value":"common_current_user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"readWorkspaces"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"writeWorkspaces"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultWorkspace"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"restrictions"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"schema"},"name":{"kind":"Name","value":"_PROJECT_Schema"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"types"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"workflows"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"references"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"cloudinaryConnector"},"name":{"kind":"Name","value":"_PROJECT_CloudinaryConnector"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cloudName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apiKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"authMethod"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"cloudinarySignature"},"name":{"kind":"Name","value":"_PROJECT_CloudinarySignature"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"versions"},"name":{"kind":"Name","value":"_PROJECT_Versions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startValidity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endValidity"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"workspaces"},"name":{"kind":"Name","value":"_PROJECT_Workspaces"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"settings"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1060}};
    doc.loc.source = {"body":" query pimLoad {\n    currentUser: common_current_user {\n        email\n        name\n        roles\n        readWorkspaces\n        writeWorkspaces\n        defaultWorkspace\n        restrictions\n    }\n    schema: _PROJECT_Schema {\n        types\n        workflows\n        references\n    }\n    cloudinaryConnector:  _PROJECT_CloudinaryConnector {\n        name\n        cloudName\n        apiKey\n        authMethod\n    }\n    cloudinarySignature: _PROJECT_CloudinarySignature {\n        signature\n        time\n        username\n    }\n    versions: _PROJECT_Versions {\n        name\n        label\n        startValidity\n        endValidity\n    }\n    workspaces: _PROJECT_Workspaces { \n        count \n        items {\n          code\n          name\n          settings                  \n        }\n    }\n    # getAllWorkspaces{\n    #     count\n    #     items{\n    #     ... on WorkspaceAlpha {\n    #       code\n    #       name\n    #       project\n    #     }\n    #     ... on WorkspaceCommon {\n    #       code\n    #       name\n    #       project\n    #     }\n    #   }\n    # }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["pimLoad"] = oneQuery(doc, "pimLoad");
        
